import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

/*
 *  @description Component
 *  Ajout d'un mask pour les numéro de téléphone
 *  et affichage d'un clavier sur mobile
 */

// const PhoneMaskInput = props => {
//   const { inputRef, ...other } = props;
//   return (
//     <MaskedInput
//       {...other}
//       mask={[
//         /\d/,
//         /\d/,
//         ' ',
//         /\d/,
//         /\d/,
//         ' ',
//         /\d/,
//         /\d/,
//         ' ',
//         /\d/,
//         /\d/,
//         ' ',
//         /\d/,
//         /\d/
//       ]}
//       guide={false}
//     />
//   );
// };
//
// PhoneMaskInput.propTypes = {
//   inputRef: PropTypes.func
// };

const RenderPhoneField = ({
  input,
  label,
  meta,
  helperText,
  style,
  id,
  fullWidth,
  InputProps
}) => {
  const displayError = !!(meta.submitFailed && meta.error);
  return (
    <TextField
      id={id}
      label={label}
      helperText={displayError ? meta.error : helperText}
      style={style}
      error={displayError}
      fullWidth={fullWidth}
      InputProps={{
        ...InputProps
        // inputComponent: PhoneMaskInput
      }}
      type="tel"
      {...input}
    />
  );
};

RenderPhoneField.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  InputProps: PropTypes.object,
  meta: PropTypes.object,
  input: PropTypes.object.isRequired,
  style: PropTypes.object,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string
};

export default RenderPhoneField;
